import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { GetOptions, PaginationOptions, RequestConfig } from 'api/types';

export type SearchClientMessageOptions = GetOptions &
  PaginationOptions & {
    query: string;
  };

export function clientMessagesSearchApi(path: string) {
  return {
    path,
    GET: ({ pageSize, pageNumber, ...rest }: SearchClientMessageOptions, config?: RequestConfig) =>
      api.get<JsonApiResponse>(path, {
        params: {
          per_page: pageSize,
          page: pageNumber,
          ...rest,
        },
        ...config,
      }),
  };
}
